var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("@/assets/banner.jpg"),"alt":"banner","height":"550"}}),_c('login-form',{attrs:{"isManager":_vm.isManager}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }